/* ----------------------------------------
    Imports
---------------------------------------- */

import { Icons } from './anp/Icons';
import { Slider } from './anp/Slider';

/* ----------------------------------------
    Cases
---------------------------------------- */

const cases = {
    anp: [
        new Icons,
        new Slider
    ]
};

/* ----------------------------------------
    Case Loader
---------------------------------------- */

export class Cases {

    constructor() {
        this._current = '';
        this._init();
    }

    /* ----------------------------------------
        Convert to Camel Case
    ---------------------------------------- */

    _camel(string) {
        return string.toLowerCase().replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
            if (+match === 0) return '';
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }

    /* ----------------------------------------
        Name
    ---------------------------------------- */

    _name(container) {
        const header = container.querySelector('.project-header');
        if(!header) return false;

        const title = header.dataset.title;

        return {
            title: title,
            module: this._camel(title)
        };
    }

    /* ----------------------------------------
        Case
    ---------------------------------------- */

    set case(view) {
        const type = view instanceof jQuery ? view[0] : view;
        const name = this._name(type);
        this._current = name.title;
        this._loader(name.module);
    }

    get current() {
        return this._current;
    }

    /* ----------------------------------------
        Reload
    ---------------------------------------- */

    reload(route) {
        this.case = route || document;
    }

    /* ----------------------------------------
        Load Scripts
    ---------------------------------------- */

    _loader(name) {
        (name in cases) && cases[name].forEach(script => script.init());
    }

    /* ----------------------------------------
        Initialize
    ---------------------------------------- */

    _init() {
        this.reload();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/cases/script.js